var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('indexCompanyList',{attrs:{"title":'资源方',"type":1}}),_c('indexCompanyList',{attrs:{"title":'采购方',"type":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }